const orderStatuses = [
  { value: 'new', title: 'Новый заказ', color: '#FF9100' },
  { value: 'waitPayment', title: 'Ожидает оплаты' },
  { value: 'confirm', title: 'Потверждён', color: '#aaaaaa' },
  { value: 'preparing', title: 'Готовится', color: '#38B2B2' },
  { value: 'assembly', title: 'В сборке', color: '#614EE2' },
  { value: 'readyForIssue', title: 'Готов к выдаче', color: '#abdb49' },
  { value: 'inDelivery', title: 'Доставляется', color: '#e91e63' },
  { value: 'completed', title: 'Завершён', color: '#1ee984' },
  { value: 'canceled', title: 'Отменен' },
]

const WORK_DAY_START = '10:00'
const WORK_DAY_END = '23:00'

const EN_LOCALE_ONLY = process.env.EN_LOCALE_ONLY === 'true'
const IN_BROWSER = typeof window !== 'undefined'
const IS_DEBUG = process.env.DEBUG === 'true'
const IS_PROD = process.env.NODE_ENV === 'production'

module.exports = {
  EN_LOCALE_ONLY,
  IN_BROWSER,
  IS_DEBUG,
  IS_PROD,
  orderStatuses,
  WORK_DAY_START,
  WORK_DAY_END,
}
